import { UserIcon, CameraIcon } from '@heroicons/react/24/outline';
import { LoadingChildren } from '../../components/loadingChildren';

interface ProfileStatsProps {
  creationYear?: number | string;
  tripCount: number;
  isLoadingProfile: boolean;
  isLoadingTrips: boolean;
}

/**
 * Profile statistics badges (member since, trip count).
 */
export const ProfileStats = ({
  creationYear,
  tripCount,
  isLoadingProfile,
  isLoadingTrips,
}: ProfileStatsProps) => {
  return (
    <div className="mt-1 flex items-center justify-center">
      <div className="flex flex-wrap justify-center gap-x-6 gap-y-4">
        <LoadingChildren
          expectedChars={12}
          loadingClassName="inline-flex items-center px-2 py-1 text-xs font-extrabold"
          loading={isLoadingProfile}
        >
          <p
            style={{ color: '#023759' }}
            className="inline-flex items-center px-2 py-1 text-xs font-extrabold"
          >
            <UserIcon className="w-4 h-4 mr-1" />
            Since: {creationYear ?? ''}
          </p>
        </LoadingChildren>
        <LoadingChildren
          expectedChars={12}
          loadingClassName="inline-flex items-center px-2 py-1 text-xs font-extrabold"
          loading={isLoadingTrips}
        >
          <p
            style={{ color: '#023759' }}
            className="inline-flex items-center px-2 py-1 text-xs font-extrabold"
          >
            <CameraIcon className="w-4 h-4 mr-1" />
            Trips: {tripCount}
          </p>
        </LoadingChildren>
      </div>
    </div>
  );
};
